/**
* Common JS file to be used between the candidates and the contact page.
*/

var JV = JV || {};
var i18n = i18n || window.i18n || {};
function isVarNullOrUndefined(val) {
    return (val !== undefined || val != null) ? true : false;
}
/**************************************************************************
 * @param id: id of the filter.
 * @return callback: any callback that needs to be called when the change event happens.
 ***************************************************************************/

function Filter(id, className, identifier, defaultCallback) {
    this.id = id;
    this.actionMapper = {};
    this.className = className;
    this.identifier = identifier;
    this.elementSelect = (identifier === 'id') ? '#' + id : '.' + className;
    this.defaultCallback = defaultCallback ? defaultCallback : function () { };
}

Filter.prototype = {
    /**
     * Will be required only when we need to dynamically inject the dropdown from the javascript.
     */
    initialize: function () {
        this.attachEvent();
    },

    /**
     * For each value change you can add the action for that value within that drop down. Also specify the callback to be called.
     */
    addAction: function (value, action, callback) {
        this.actionMapper[value] = {};
        this.actionMapper[value].action = action;
        this.actionMapper[value].callback = callback;
    },

    /**
    *** Attaching events to the element based on the class/id attribute.
    **/
    attachEvent: function () {
        var me = this;
        $(document).on('change', this.elementSelect, function () {
            var selectedValue = $(this).val();
            if (me.actionMapper[selectedValue] && me.actionMapper[selectedValue].action && me.actionMapper[selectedValue].callback) {
                me.actionMapper[selectedValue].callback();
            } else {
                me.defaultCallback();
            }
        });
    },

    /**
     * get the selected value of the element.
     */
    getSelection: function () {
        $(this.elementSelect).val();
    },

    /**
     * Used for saved searches. Just pass the value and it will set that selected value.
     */
    setSelection: function (value) {
        $(this.elementSelect).val(value);
    }
};
/**************************************************************************
 *
 * @param  gridId: div id where the grid is contained.
 * @param  formId: which form data to submit when the grid needs to refresh.
 *************************************************************************/
function Grid(gridId, formId) {
    this.gridId = gridId;
    this.formId = formId;
}

Grid.prototype = {

    initialize: function () {
        this.attachEvent();
    },

    attachEvent: function () { },

    Const: {
        'LOADING': i18n['JV_NEWPERSON_LOADING'],
        'PROCESSING': i18n['JV_NEWPERSON_PROCESSING']
    },

    /**
     * This can be called from anywhere from the UI using
     * JV.Person.Global.grid.makeCallForGrid();
     */
    makeCallForGrid: function (callback) {
        JV.Util.showLoadingState();
        if (!callback) {
            callback = function () { };
        }
        var me = this;
        $('#' + this.formId).on('submit', function () {
            // the call for grid always puts the action as initialize so change the action to initialize.
            $('#action').val('initialize');
            // So that we dont send the default values to the backend.
            JV.Person.removeFadedText();
            dataString = $(this).serialize();
            JV.Util.makeAjaxRequest({
                type: 'POST',
                url: JV.AJAX_URL,
                data: dataString,
                ajaxType: 'initialize',
                /*
                success: function(data) {
                    me.renderGrid(data);
                },
                */
                dataFilter: function (data) {
                    me.renderGrid(data);
                    JV.Util.removeLoadingState();
                    // After the call is made reset the page to 0, it will be set each time when the next/previous
                    // page call is made and is not required for the searches which is by default 0.
                    $('#' + JV.Person.elementConst['PAGE_ELEMENT']).val(0);
                    // Also reset the values for the drop downs.
                    JV.Person.resetValues();
                    callback();
                },
                error: function(xhr, status, error) {
                    // Handle 500 Internal Server Error
                    console.error('Error message:', error);
                    JV.Util.removeLoadingState();
                    JV.Person.resetValues();
                }
            });
            return false;
        });
        $('#' + this.formId).trigger('submit');
        // adding the default values to the UI.
        JV.Person.addFadedText();
        $('#' + this.formId).off('submit');
    },

    //VA: HaCk For detail navigation.
    makeJSONCallForGrid: function (callback, page) {
        JV.Util.showLoadingState();
        if (!callback) {
            callback = function () { };
        }
        var me = this;
        $('#' + this.formId).on('submit', function () {
            // the call for grid always puts the action as initialize so change the action to initialize.
            $('#action').val('initialize');
            // So that we dont send the default values to the backend.
            JV.Person.removeFadedText();

            // set the page for which you need the results.
            $('#jv-page').val(page);
            $(this).append("<input type='hidden' name='type' value='json' />");
            dataString = $(this).serialize();
            JV.Util.makeAjaxRequest({
                type: 'POST',
                url: JV.AJAX_URL,
                data: dataString,
                ajaxType: 'initialize',
                async: false,
                /*
                success: function(data) {
                    me.renderGrid(data);
                },
                */
                dataFilter: function (data) {
                    callback(data);
                }
            });
            return false;
        });
        $('#' + this.formId).trigger('submit');
        // adding the default values to the UI.
        JV.Person.addFadedText();
        $('#' + this.formId).off('submit');
    },

    renderGrid: function (data) {
        //$('#'+this.gridId).html(data);
        var _width = $('#' + this.gridId).width();
        $('#' + this.gridId).replaceWith(data);
        $('#' + this.gridId).css({ 'width': _width + 'px' });
    }
};

/**************************************************************************
 * The modal dialog boxes are complicated enough to create a seperate utility class for them.
 *
**************************************************************************/

JV.Modal = {
    // modal dialog rendering element.
    modalElement: 'jv-modalDialog',
    elementConst: {
        OVERLAY_SORTBY: 'jv-overlaySortBy'
    },

    Const: {
        'LOADING': i18n['JV_NEWPERSON_LOADING_']
    },

    //Initialize the modal dialog.
    initialize: function () {
        $.jqm.params.modal = true;
        this.attachEvent();
        $('#' + this.modalElement).jqm();       // initialization.
    },

    // Show the modal dialog
    render: function (params, callback, ifSlide) {
        var args = {};
        args.ajaxType = params.action;
        args.url = params.url ? params.url : JV.AJAX_URL;
        if (callback) {
            args.success = callback;
        } else {
            args.success = function (content) {
                JV.Modal.show(content, ifSlide);
            }
        }

        // This is the temporary solution as we only need the company Id for testing.
        //params.companyId = $('#companyId').val();
        // data for the backend.
        args.data = params;
        JV.Util.makeAjaxRequest(args);
    },

    show: function (content, ifSlide) {
        $('#' + this.modalElement).html(content);
        $('#' + this.modalElement).jqmShow(ifSlide);
    },

    // Hide the modal dialog.
    hide: function () {
        //Vinoth: Added to reposition the modal window while closing.
        $('#' + this.modalElement).css({ 'top': '', 'left': '' });
        $('#' + this.modalElement).jqmHide();
    },

    attachEvent: function () {
        var me = this;
        var _person = JV.Person;
        var _modal = JV.Modal;
        // For any cancel button attach the event to close the modal dialog box.
        // remember the cancel button should have the key as cancel(KEY='CANCEL')
        $(document).on('click keydown', '*[KEY="CANCEL"]', function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.which === 13 || e.keyCode === 13))) {
                var _process = true;
                if (_process) {
                    if (_person.resetValue) {
                        _person.resetValues();
                    }
                    $('#' + _person.elementConst['REQUISITION_ELEMENT']).val($('#' + _person.elementConst['REQUISITION_ELEMENT']).attr('PREVIOUS_VALUE'));
                    // Remove the modal contents.
                    me.hide();
                    // Just to remove the load of the DOM, in any case if the HTML is still inside.
                    $('#' + me.modalElement).html('');
                    // For IE
                    var userAgent = window.navigator.userAgent;
                    if ($(e.currentTarget).hasClass('jv-refreshPage') && (userAgent.indexOf('MSIE ') !== -1 || !!userAgent.match(/Trident\//))) {
                        location.assign(location.href);
                    }
                }
            }
        });
        $(document).on('click keydown', '*[KEY="DETAIL_ACTION_CANCEL"]', function (e) {
            if (e.type === 'click' || (e.type === 'keydown' && (e.which === 13 || e.keyCode === 13))) {
                var _process = true;
                if (_process) {
                    JV.Person.isDirtyForm = false;
                    var linkKey = $(this).attr('LINK_KEY');
                    var replaceKey = $(this).attr('REPLACE_KEY');
                    var obj = $('ul#jv-accordion a.heading');
                    var formName = $(this).closest('form').attr('name');
                    $('#' + formName)[0].reset();
                    $('#' + formName + ' :hidden').val('');
                    // JV.Person.addContactFadedText();
                    if (typeof (linkKey) !== 'undefined' && typeof (replaceKey) !== 'undefined' && replaceKey !== '' && linkKey !== '') {
                        $('#' + linkKey).html(replaceKey);
                    }
                    if ($(obj).parent().hasClass('current')) {
                        $(obj).siblings('ul').slideUp('fast', function () {
                            $(obj).parent().removeClass('current');
                        });
                    }
                }
            }
        });
        $(document).on('change', '*[KEY="REFRESH_GRID"]', function () {
            _person['mode'] = null;
            if ($(this).attr('id') === 'requisitions' && ($(this).val() !== -1 && $(this).val() !== -2)) {
                $('#' + _person.elementConst['SELECTED_JOBID']).val('');
                me.hide();
                _person.Global.grid.makeCallForGrid();
            } else if ($(this).attr('id') !== 'requisitions') {
                me.hide();
                _person.Global.grid.makeCallForGrid();
            }
        });
        /**
         * For any dropdown that needs an update for the grid create a key for that element and set it as
         * -> KEY='REFRESH_GRID'
         */
        //Overlay Sorting
        $(document).on('click', '*[KEY="OVERLAY_SORT"]', function () {
            var _sortOn = $(this).attr('REVERSE_KEY');
            JV.Person.getOverlayJobs(0, _sortOn);
        });
    }
};


/**************************************************************************
 * Utility for making ajax calls and showing confirmation messages.
 *
**************************************************************************/
JV.Util = {

    cacher: {},
    loggingEnabled: false,
    extend: function (subclass, superclass) {
        function TempFunction() { };
        TempFunction.prototype = superclass.prototype;
        subclass.prototype = new TempFunction();
        subclass.prototype.constructor = subclass;
        subclass.prototype.superclass = superclass.prototype;
    },

    Const: {
        'OFCCP': i18n['JV_NEWPERSON_SELECT_JOB_FOR_OFCCP_COMPLAINT_SEARCH'],
        'SELECT_JOB': i18n['JV_NEWPERSON_SELECT_JOB'],
        'CANCEL': i18n['JV_NEWPERSON_CANCEL'],
        'CONTINUE': i18n['JV_NEWPERSON_CONTINUE'],
        'SUBMIT_TO_HIRING_MANAGER': i18n['JV_NEWPERSON_SUBMITTED_TO_HIRING_MANAGER'],
        'SELECTED_JOB': i18n['JV_NEWPERSON_SELECTED_JOB_'],
        'NON_JOB_RELATED': i18n['JV_NEWPERSON_NON_JOB_RELATED'],
        'FADE_TIME': 100,
        'DELAY_TIME': 4000
    },

    /**
     * Important attribute of args is the ajaxType which uniquely identifies what type of ajax request is being sent
     * to the backend.
     * Use Case: User can send multiple request for the same call. We want to avoid that as it can result in ambigious behavior.
     * The 'ajaxType' will abort the previous call made and make a new call for the  same ajax type.
     */
    makeAjaxRequest: function (args) {
        // clear the timeout.
        apiTimeoutClear();
        //          if( !args.url || typeof args.url != 'string' ){
        //                  return;
        //          }
        args.contentType = args.contentType ? args.contentType : 'application/x-www-form-urlencoded; charset=UTF-8';
        args.traditional = true;
        args.type = 'POST';
        args.dataType = 'html';
        args.url = args.url ? args.url : JV.AJAX_URL;
        // if there is already an xhr request for the same action has been fired and it hasn't retured yet, abort it first and then make a new request.
        if (this.cacher[args.ajaxType]) {
            (this.cacher[args.ajaxType]).abort();
            this.cacher[args.ajaxType] = null;
        }
        // cache the ajax call
        if (typeof _gaq != 'undefined') {
            _gaq.push(['_trackEvent', JV.PAGE_TYPE, args.ajaxType ? args.ajaxType : 'unknown', JV.COMPANYEID]);
        }
        this.cacher[args.ajaxType] = $.ajax(args);
    },

    // Shows the given messages at the top of the grid and fades out within the given time of FADE_TIME.
    showMessage: function (message) {
        // for iframe purpose if the campaign id is present in the UI. show the message in the parent frame.
        if (isVarNullOrUndefined($('#jv-campaigneid').val()) && $('#jv-campaigneid').val().trim() !== '') {
            parent.JV.showDropDownMessage(message);
        } else {
            $('#' + JV.Person.elementConst['SUCCESS_MSG_ELEMENT']).show();
            $('#' + JV.Person.elementConst['SUCCESS_MSG_ELEMENT']).text(message).slideDown(this.Const['FADE_TIME']).delay(this.Const['DELAY_TIME']).slideUp(this.Const['FADE_TIME']);
        }

    },

    // Shows the given error messages at the top of the grid and fades out within the given time of FADE_TIME.
    showErrorMessage: function (message) {
        if (isVarNullOrUndefined($('#jv-campaigneid').val()) && $('#jv-campaigneid').val().trim() !== '') {
            parent.JV.showDropDownMessageError(message);
        }
        else {
            $('.jv-showErrorMsg').css({ 'display': '', 'color': '' });
            $('.jv-showErrorMsg').text(message);
        }
        JV.Person.resetValues();
    },

    validateEmail: function (emailValue) {
        if (!window.EMAIL_REGEX) {
            throw new Error('EMAIL_REGEX is not defined');
        }
        var emailPattern = new RegExp(window.EMAIL_REGEX);
        return emailPattern.test(emailValue);
    },

    validateURL: function (url) {
        var regexp = /([\-\w]+\.)+\w{2,3}(\/[%\-\w]+(\.\w{2,})?)*(([\w\-\.\?\\/+@&#;`~=%!]*)(\.\w{2,})?)*\/?/;
        return regexp.test(url);
    },

    isValidZipCode: function (zipCode) {
        var zipCodePattern = /^\d{5}([\-]\d{4})?$/;
        return (zipCodePattern.test(zipCode));
    },

    isNumeric: function (input, ifZeroAllowed) {
        var ValidChars = '0123456789';
        var IsNumber = true;
        var Char;
        for (var i = 0; i < input.length && IsNumber === true; i++) {
            Char = input.charAt(i);
            if (ValidChars.indexOf(Char) === -1) {
                IsNumber = false;
            }
        }
        return IsNumber;
    },

    isDecimal: function (input) {
        var pattern = /^\d+([,]\d+)*[.]*\d+$/;
        return pattern.test(input && input.trim());
    },

    isAmount: function (input) {
        var pattern = /^\d+([,]\d+)*[.]*\d{2}$/;
        return pattern.test(input && input.trim());
    },

    isValidPhone: function (phoneNumber) {
        //var phoneNumberPattern = /^\([1-9]\d{2}\)\s?\d{3}\-\d{4}$/;
        var phoneNumberPattern = /^[A-Z0-9 #\(\)\-\.\+\u00AD]*$/;     // Making it more lenient for supporting legacy contacts
        return (phoneNumberPattern.test(phoneNumber));
    },
    showLoadingState: function () {
        var template = "<center><img src='/__assets__/images/ajax-loader.gif' style='padding-top: 50%'/></center>";
        JV.Modal.show(template);
    },

    showLoadingProcess: function (parentRef) {
        var padding_width = parentRef.paddingWidth();
        var padding_height = parentRef.paddingHeight();

        if (padding_width == 0) {
            var width = parentRef.width() + 10;
        }
        else {
            var width = parentRef.width() + padding_width;
        }

        if (padding_height == 0) {
            var height = parentRef.height() + 10;
        }
        else {
            var height = parentRef.height() + padding_height;
        }



        var tempdiv = $('<div>').css({
            'height': height,
            'width': width,
            'top': '-5px',
            'left': '-5px',
            'position': 'absolute'
        });

        //_parentDiv.parent().append( tempdiv );
        $(tempdiv).addClass('alpha60');
        parentRef.append(tempdiv);
        return tempdiv;
    },

    showProcessingState: function () {
        this.showLoadingState();
    },

    removeLoadingState: function () {
        JV.Modal.hide();
    },

    log: function (message) {
        if (!this.loggingEnabled) {
            return;
        }
        if (typeof console !== 'undefined' && typeof console.log === 'function') {
            //console.log( message );
        }
    }
};

var JV = JV || {};
JV.Person = {

    mode: null,
    isJobOverlay: null,
    searchKeyword: '',
    addedTagNames: [],
    addRowIdentifier: 20,
    formData: null,
    modifiedFormData: null,
    originalURL: null,
    modifiedURL: null,
    pageNavigationType: null,
    isDirtyForm: null,
    changedWebsiteFormData: null,
    originalWebsiteFormData: null,

    Const: {
        'UNSUPPORTED_FILE_TYPE': i18n['JV_NEWPERSON_THAT_FILE_TYPE_IS_NOT_SUPPORTED_PLEASE_UPLOAD_A_VA'],
        'MESSAGES_SEND_SUCCESS': i18n['JV_NEWPERSON_MESSAGE_HAS_BEEN_SENT_TO_CONTACT_'],
        'NOTE_ADD_SUCCESS': i18n['JV_NEWPERSON_NOTE_HAS_BEEN_ADDED_TO_CONTACT_RECORD_'],
        'NOTE_EDIT_SUCCESS': i18n['JV_NEWPERSON_NOTE_HAS_BEEN_UPDATED_'],
        'NOTE_DELETE_SUCCESS': i18n['JV_NEWPERSON_NOTE_HAS_BEEN_DELETED_'],
        'TASK_ADD_SUCCESS': i18n['JV_NEWPERSON_TASK_HAS_BEEN_ADDED_TO_CONTACT_RECORD_'],
        'TASK_EDIT_SUCCESS': i18n['JV_NEWPERSON_TASK_HAS_BEEN_UPDATED_'],
        'TASK_DELETE_SUCCESS': i18n['JV_NEWPERSON_TASK_HAS_BEEN_DELETED_'],
        'TASK_UPDATE_SUCCESS': i18n['JV_NEWPERSON_TASK_HAS_BEEN_UPDATED_'],
        'TAGS_SAVE_SUCCESS': i18n['JV_NEWPERSON_TAGS_HAVE_BEEN_UPDATED_'],
        'CAMPAIGN__NAME_SELECT_ERROR': i18n['JV_NEWPERSON_PLEASE_SELECT_ATLEAST_ONE_CAMPAIGN_'],
        'SEARCH_NAME_SELECT_ERROR': i18n['JV_NEWPERSON_PLEASE_SELECT_A_SAVED_SEARCH_'],
        'CANDIDATE_SELECT_ERROR': i18n['JV_NEWPERSON_PLEASE_SELECT_ONE_OR_MORE_CONTACT_'],
        'CONTACT_MERGE_SELECT_ERROR': i18n['JV_NEWPERSON_PLEASE_SELECT_TWO_OR_MORE_CONTACTS_'],
        'CONTACT_SELECT_ERROR': i18n['JV_NEWPERSON_PLEASE_SELECT_ONE_OR_MORE_CONTACTS_'],
        'ENTER_LOCATION': i18n['JV_NEWPERSON_ENTER_ZIP_CODE_OR_CITY'],
        'ENTER_COMPANY': i18n['JV_NEWPERSON_CURRENT_COMPANY'],
        'ENTER_TITLE': i18n['JV_NEWPERSON_CURRENT_TITLE'],
        'ENTER_EDUCATION': i18n['JV_NEWPERSON_ENTER_SCHOOL_DEGREE_OR_MAJOR'],
        'ENTER_SEARCH_TEXT': i18n['JV_NEWPERSON_ENTER_KEYWORD_OR_NAME'],
        'SEARCH_SUCCESS': i18n['JV_NEWPERSON__SEARCH_SAVED_SUCCESSFULLY'],
        'LOADING': i18n['JV_NEWPERSON_LOADING_'],
        'SEARCH_NAME_EXITS': i18n['JV_NEWPERSON_SEARCH_NAME_ALREADY_EXISTS_PLEASE_CREATE_A_UNIQUE_'],
        'DELETE_SUCCESSFUL': i18n['JV_NEWPERSON_DELETE_SUCCESSFUL'],
        'COLLECTION_NAME_REQUIRED': i18n['JV_NEWPERSON_COLLECTION_NAME_IS_REQUIRED'],
        'SUBJECT_REQUIRED': i18n['JV_NEWPERSON_SUBJECT_IS_REQUIRED'],
        'MESSAGE_REQUIRED': i18n['JV_NEWPERSON_MESSAGE_IS_REQUIRED'],
        // Pavan: use the below message when contact details page rolls out with the Do Not Contact status
        //'EMAIL_REQUIRED': 'Selected contact(s) doesn't have email id or having status as Do Not Contact.',
        'EMAIL_REQUIRED': i18n['JV_NEWPERSON_SELECTED_CONTACT_S_DOESN_T_HAVE_EMAIL_ID_'],
        'SELECT_DIFFERENT_JOB': i18n['JV_NEWPERSON_SELECT_DIFFERENT_JOB'],
        'FILE_SELECT_ERROR': i18n['JV_NEWPERSON_PLEASE_SELECT_FILE'],
        'IMPORT_WARNING_MSG': i18n['JV_NEWPERSON_ONE_OR_MORE_OF_THE_CONTACTS_YOU_HAVE_ADDED_LOOK_LI'],
        'IMPORT_INCOMPLETE_MSG': i18n['JV_NEWPERSON_IN_ORDER_TO_IMPORT_A_CONTACT_THE_CONTACT_MUST_HAVE'],
        'IMPORT_DUPLICATE_MSG': i18n['JV_NEWPERSON_WE_HAVE_DETECTED_THAT_ONE_OR_MORE_OF_THE_CONTACTS_'],
        'IMPORT_MISSING_COLS_MSG': i18n['JV_NEWPERSON_YOUR_UPLOADED_FILE_DOES_NOT_FOLLOW_THE_NECESSARY_S'],
        'IMPORT_UNSUPPORTED_COLS_MSG': i18n['JV_NEWPERSON_YOU_HAVE_COLUMNS_THAT_WE_DO_NOT_USE_WHILE_IMPORTIN'],
        'IMPORT_SUCCESS_MSG': i18n['JV_NEWPERSON__CANDIDATE_S_WERE_UPLOADED_SUCCESSFULLY_'],
        'IMPORT_PENDING_MSG': i18n['JV_NEWPERSON_IT_WILL_TAKE_A_LITTLE_BIT_OF_TIME_TO_IMPORT_ALL_OF'],
        'IMPORT_MAX_SIZE_EXCEEDED': i18n['JV_NEWPERSON_YOUR_FILE_SIZE_IS_OVER_10_MB_IN_SIZE_AND_CANNOT_BE'],
        'IMPORT_DUP_TOOLTIP': i18n['JV_NEWPERSON_WE_CHECK_THE_FILE_THAT_YOU_ARE_UPLOADING_AGAINST_Y'],
        'IMPORT_START_SUCCESS': i18n['JV_NEWPERSON_CONTACT_IMPORT_HAS_BEEN_STARTED_'],
        'DELETE_CONFIRMATION': i18n['JV_NEWPERSON_ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_'],
        'EDIT': 'EDIT',
        'DETAIL': 'DETAIL',
        // Pavan: use the below message when contact details page rolls out with the Do Not Contact status
        //'SEND_JOBVITE_EMAIL_ERROR': '{0} of {1} contact(s) do not have an valid email address or their status is Do Not Contact. No jobvites will be sent to them.'
        'SEND_JOBVITE_EMAIL_ERROR': i18n['JV_NEWPERSON__0_OF_1_CONTACT_S_DO_NOT_HAVE_AN_VALID_EMAIL_ADDRE'],
        'FIRST_NAME': i18n['JV_NEWPERSON_FIRST_NAME'],
        'MIDDLE_NAME': i18n['JV_NEWPERSON_MIDDLE_NAME'],
        'LAST_NAME': i18n['JV_NEWPERSON_LAST_NAME'],
        'NAME': i18n['JV_NEWPERSON_NAME'],
        'CITY': i18n['JV_NEWPERSON_CITY'],
        'ADDRESS': i18n['JV_NEWPERSON_ADDRESS'],
        'JOB': i18n['JV_NEWPERSON_JOB'],
        'PRIMARY_EMAIL': i18n['JV_NEWPERSON_PRIMARY_EMAIL_ADDRESS'],
        'PRIMARY_PHONE': i18n['JV_NEWPERSON_PRIMARY_PHONE'],
        'ZIPCODE': i18n['JV_NEWPERSON_ZIPCODE'],
        'INVALID_ZIPCODE': i18n['JV_NEWPERSON_PLEASE_ENTER_A_VALID_ZIP_CODE_'],
        'COMPANY': i18n['JV_NEWPERSON_COMPANY'],
        'SKYPE': i18n['JV_NEWPERSON_SKYPE_ID'],
        'TITLE': i18n['JV_NEWPERSON_TITLE'],
        'PHONE': i18n['JV_NEWPERSON_PHONE_NUMBER'],
        'INVALID_PHONE': i18n['JV_NEWPERSON_INVALID_PHONE_NUMBER_S_'],
        'WEBSITE': i18n['JV_NEWPERSON_WEBSITE'],
        'EMAIL': i18n['JV_NEWPERSON_EMAIL_ADDRESS'],
        'INVALID_EMAIL': i18n['JV_NEWPERSON_PLEASE_ENTER_A_VALID_EMAIL_ADDRESS_'],
        'CONTACT_SUCCESSFUL': i18n['JV_NEWPERSON_CONTACT_IS_SAVED_SUCCESSFULLY_'],
        'INVALID_NUMBER': i18n['JV_NEWPERSON_PLEASE_ENTER_A_VALID_NUMBER_'],
        'URL_ERROR_TEXT': i18n['JV_NEWPERSON_PLEASE_ENTER_VALID_URL_'],
        'LINKEDIN_URL_TEXT': i18n['JV_NEWPERSON_ENTER_LINKEDIN_URL_'],
        'FACEBOOK_URL_TEXT': i18n['JV_NEWPERSON_ENTER_FACEBOOK_URL_'],
        'TWITTER_URL_TEXT': i18n['JV_NEWPERSON_ENTER_TWITTER_URL_'],
        'SERVER_BUSY': i18n['JV_NEWPERSON_IMPORTING_CONTRACTS_MAY_TAKE_A_FEW_MINUTES_YOU_MAY'],
        'NAME_CONSTRAINTS': i18n['JV_NEWPERSON_NAME_CAN_NOT_EMPTY_AND_IS_ONLY_ALPHANUMERIC_'],
        'NAME_EMPTY': i18n['JV_NEWPERSON_NAME_CAN_NOT_BE_EMPTY'],
        'SAVE': i18n['JV_NEWPERSON_SAVE'],
        'SAVING': i18n['JV_NEWPERSON_SAVING_'],
        'INVALID_DATE': i18n['JV_NEWPERSON_INVALID_EMPTY_DATE'],
        'EMPTY_VALUE': i18n['JV_NEWPERSON_EMPTY_VALUE_S_ARE_NOT_ALLOWED_'],
        'CONTENT_UNAVAILABLE': i18n['JV_NEWPERSON_NO_CONTENT_AVAILABLE_FOR_0_'],
        'PROFILE_URL': i18n['JV_NEWPERSON_PROFILE_URL'],
        'JOBSELECT_ERROR': i18n['JV_NEWPERSON_YOU_MUST_SELECT_A_JOB_TO_PROCEED_'],
        'CAMPAIGN_ERROR': i18n['JV_NEWPERSON_YOU_MUST_SELECT_A_CAMPAIGN_TO_PROCEED_'],
        'OFCCP_JOBSELECT_ERROR': i18n['JV_NEWPERSON_YOU_MUST_SELECT_A_REQUISITION_TO_MEET_OFCCP_COMPLI'],
        'NO_CAMPAIGN': i18n['JV_NEWPERSON_CONTACT_IS_NOT_ASSOCIATED_WITH_ANY_CAMPAIGN_S_'],
        'NO_SOCIAL_CONTACT': i18n['JV_NEWPERSON_NO_SOCIAL_CONTENT_AVAILABLE_FOR_THIS_CONTACT_'],
        'NOTES': 'NOTES',
        'OPEN_TASKS': 'OPEN TASKS',
        'COMPLETE_TASKS': 'COMPLETE TASKS',
        'MESSAGES': 'MESSAGES',
        'NO_ACTIVITY': i18n['JV_NEWPERSON_THERE_ARE_NO_0_FOR_THIS_CONTACT_'],
        'DOC_UPLOAD_SUCCESSFUL': i18n['JV_NEWPERSON_DOCUMENT_WAS_SUCCESSFULLY_UPLOADED'],
        'CONTACT_ZERO_ATTACHMENT': i18n['JV_NEWPERSON_THIS_CONTACT_DOESN_T_HAVE_A_RESUME_COVER_LETTER_OR'],
        'DRAFT': 'Draft',
        'URL_MAX_LIMIT_REACHED': i18n['JV_NEWPERSON_YOU_HAVE_EXCEEDED_THE_MAXIMUM_LIMIT_FOR_URL_WHICH_'],
        'RESUME': 'RESUME'
    },

    elementConst: {
        //URL_REFRESH: 'jv-urlRefresh',
        REQUISITION_ELEMENT: 'requisitions',
        SEARCH_REQUISITION_ELEMENT: 'jv-selectJobStatus',
        OFCCP_ELEMENT: 'jv-selectJobLink',
        OFCCP_RADIO: 'jv-ofccpJobId',
        SELECT_COLLECTION_ELEMENT: 'jv-selectCollection',
        ADD_NEW_COLLECTION_ELEMENT: 'jv-addNewCollection',
        ADD_COLLECTION: 'jv-addNewCollectionArea',
        SEARCH_ELEMENT: 'jv-searchButtonTop',
        SEARCH_TEXT_ELEMENT: 'jv-requisitionText',
        SEARCH_NAME_TEXT_ELEMENT: 'renameSavedSearch',
        SELECTED_JOBID: 'jobIds',
        ACTIONS_COMBO_ELEMENT: 'jv-actionsCombo',
        ERROR_ELEMENT: 'jv-selectError',
        SELECTED_JOB_ELEMENT: 'jv-jobId',
        CANDIDATE_IDS: 'candidateIds',
        ALLCANDIDATE_GRID: 'jv-AllCandidateGrid',
        CANDIDATE_GRID: 'jv-searchCandidateGrid',
        SELECTION_MSG_ELEMENT: 'jv-selectionMsg',
        SUCCESS_MSG_ELEMENT: 'jv-successMessage',
        CHANGE_STATUS_ELEMENT: 'jv-changeStatus',
        SAVED_SEARCH: 'jv-savedSearch',
        CANDIDATE_ID_ELEMENT: 'jv-candidateId',
        HIRING_MANAGER_ELEMENT: 'jv-managerName',
        MAIL_SUBJECT_ELEMENT: 'jv-mailSubject',
        MAIL_CONTENT_ELEMENT: 'jv-mailContent',
        SAVED_SEARCH_NAME_ELEMENT: 'jv-searchName',
        NAME_OR_KEYWORDS_SEARCH_ELEMENT: 'jv-name_or_keywords',
        WORKFLOWSTATEIDS_ELEMENT: 'jv-workflowStateIds',
        STATUSES_ELEMENT: 'jv-statuses',
        JOB_TYPES_ELEMENT: 'jv-jobTypes',
        SOURCEIDS_ELEMENT: 'jv-sourceIds',
        SAVED_COLLECTIONS_ELEMENT: 'saved_collections',
        DISTANCE_ELEMENT: 'jv-distance',
        SELECTED_SOURCE: 'jv-sourceSelections',
        SELECTED_REQUISITION: 'jv-requisitionSelections',
        SELECTED_JOBTYPE: 'jv-jobTypeSelections',
        SELECTED_STATUSES: 'jv-workflowStateSelections',
        SELECTED_DISTANCE: 'jv-distanceSelections',
        SELECTED_COLLECTION: 'jv-collectionSelections',
        PAGE_ELEMENT: 'jv-page',
        ALL_CHECKBOX: 'checkboxAll',
        CLEARALL_CHECKBOX: 'clearAll',
        SEARCH_OPTIONS_ELEMENT: 'jv-searchOptions',
        PAGE_NUMBER: 'jv-pageNum',
        OVERLAY_SORTBY: 'jv-overlaySortBy',
        SORT_VALUE_ELEM: 'sortBy',
        SEARCH_OPTION_PANEL: 'jv-option',
        SEARCH_OPTION_IMAGE: 'jv-optionsImg',
        SELECTED_NUMBER_ELEM: 'number',
        TOGGLE_FILTER_ELEM: 'jv-toggleFilter',
        FILTERBY_PANEL_CONTENT: 'jv-panelFilter',
        RENAME_SAVED_SEARCH_LINK: 'jv-renameLink',
        DELETE_SAVED_SEARCH_LINK: 'jv-deleteLink',
        SELECT_COLLECTION: 'jv-selectCollectionSelect',

        SELECT_COLLECTION_INPUT: 'jv-selectCollectionInput',
        SELECTION_HEADER: 'jv-selectionHeader',
        QUERY_TEXTAREA: 'q',
        SEARCH_COMPANY: 'jv-company',
        SEARCH_TITLE: 'jv-title',
        SEARCH_EXPERIENCE: 'jv-experience',
        SEARCH_EDUCATION: 'jv-education',
        SEARCH_CHECKALL: 'searchAll',
        SEND_OFFER_LETTER: 'sendOfferLetter',
        SAVE_SEARCH_LINK: 'jv-saveSearchLink',
        SEARCH_LIST_FORM: 'jv-searchListForm',
        SELECTED_REQUISITION_ID: 'jv-requisitionId',
        LOCATION_ELEMENT: 'jv-location',
        SELECTED_JOB_DESCRIPTION: 'jv-selectedJobDescription',
        MESSAGE_SUBJECT: 'jv-mailSubject',
        MESSAGE_CONTENT: 'jv-mailContent',
        MESSAGE_ERROR: 'jv-SearchError',
        REJECT_EMAIL_ELEMENT: 'jv-rejectEmail',
        REJECT_EMAIL_SECTION: 'jv-rejectEmailSection',
        QUICK_VIEW_EID: 'jv-quickViewEId', //Used when view-details button is clicked on quick view.
        PANEL_HEADER: 'jv-PanelHeader',
        TASK_FROM_DATE: 'jv-taskStartDate',
        TASK_END_DATE: 'jv-taskEndDate',
        TASK_NOTES: 'jv-taskNotes',
        NOTE_MESSAGE: 'jv-noteMessage',
        NOTE_SUBJECT: 'jv-noteSubject',
        FIRST_NAME: 'jv-firstName',
        MIDDLE_NAME: 'jv-middleName',
        LAST_NAME: 'jv-lastName',
        ADDRESS: 'jv-address',
        CITY: 'jv-city',
        ZIPCODE: 'jv-zipcode',
        TITLE: 'jv-jobTitle',
        SKYPE: 'jv-skype',
        COMPANY: 'jv-jobCompany',
        WEBSITE: 'website1',
        PHONE: 'jv-Phone0',
        EMAIL: 'jv-Email0',
        BASE_TYPE: 'Contact'
    },

    attachParentEvent: function () {
        var _person = this;
        var _elementConst = _person.elementConst;

        $(document).on('change', '#statusId', function () {
            var _val = $(this).val();
            if (_val === 'CANDIDATE') {
                _person.process('addToRequisitionOverlay');
            }
        });

        $(document).on('click', 'li[KEY="PREVIOUS"], li[KEY="NEXT"]', function () {
            var _tabs = JV.Tabs;
            var navType = $($(this).parent()).attr('navigationType');
            var pageNum = $(this).attr('page');
            switch (navType) {
                case 'CANDIDATE_GRID':
                    $('#' + _elementConst['PAGE_ELEMENT']).val(pageNum);
                    _person.Global.grid.makeCallForGrid();
                    break;
                case 'JOBS_GRID':
                    $('#' + _elementConst['PAGE_NUMBER']).val(pageNum);
                    if (_HRTECHUI_ENABLED) {
                        _person.getOverlayJobs(pageNum, null, null, true);
                    } else {
                        _person.getOverlayJobs(pageNum, null, null, false);
                    }
                    break;
                case 'CAMPAIGNS_GRID':
                    _person.getCampaignsOverlay(pageNum);
                    break;
                case 'PERSON_GRID':
                    $('#' + _elementConst['PAGE_NUMBER']).val(pageNum);
                    $('#jv-personViewLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
                    if ($('input[name="ifassignedUserType"]').length) {
                        JV.Person.loadPersonHelper(['Recruiter', 'Research'], pageNum, true);
                    } else {
                        JV.Person.loadPerson(pageNum);
                    }
                    break;
                default:
                    break;
            }
        });

        // ******************** CAMPAIGNS OVERLAY *******************
        //VA: used in contact details also. Overlay Sorting for campaign
        $(document).on('click', '*[KEY="OVERLAY_CAMPAIGN_SORT"]', function () {
            var sortyby = $(this).attr('REVERSE_KEY');
            JV.Person.getCampaignsOverlay(0, sortyby);
        });

        //select campaign from contact list page and search button on campaign overlay.
        $(document).on('click', '.jv-selectCampaign', function () {
            _person.getCampaignsOverlay(0);
        });

        $(document).on('click', '.jv-buttonWrapperCampaignTop', function () {
            if ($('#jv-campaignText').val() === undefined || $('#jv-campaignText').val() === null || $('#jv-campaignText').val().trim() === '') {
                return;
            }
            _person.getCampaignsOverlay(0);
        });

        // campaign overlay search box.
        $(document).on('keyup', '#jv-campaignText', function (e) {
            if (e.keyCode === 13 || e.which === 13) {
                _person.getCampaignsOverlay(0);
            }
        });

        // campaign overlay drop down.
        $(document).on('change', '#jv-campaignStatus', function () {
            $('#jv-campaignLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
            _person.getCampaignsOverlay(0);
        });


        // ****************** REQUISITION OVERLAY *******************
        $(document).on('click', '#' + _elementConst['SEARCH_ELEMENT'], function () {
            _person.getOverlayJobs(0);
        });

        //dropdown
        $(document).on('change', '#' + _elementConst['SEARCH_REQUISITION_ELEMENT'], function () {
            _person.getOverlayJobs(0);
        });

        //textfield
        $(document).on('keyup', '#' + _elementConst['SEARCH_TEXT_ELEMENT'], function (e) {
            if (e.keyCode === 13 || e.which === 13) {
                _person.getOverlayJobs(0);
            }
        });

    },// end attachEvent

    //Requisition/Job Overlay
    getOverlayJobs: function (page, sortBy, mode, multiValSelect, jobStateVal) {
        if (_HRTECHUI_ENABLED) {
            multiValSelect = true;
        } else {
            multiValSelect = false;
        }
        var _modal = JV.Modal;
        // drop down in the grid for the requisition.
        var jobStateValue = $('#' + this.elementConst['SEARCH_REQUISITION_ELEMENT']).val();
        // element search box id on the requisition overlay.
        var query = $('#' + this.elementConst['SEARCH_TEXT_ELEMENT']).val();
        _modal.render({
            action: 'getJobs',
            url: JV.GET_REQUISITION_URL,
            jobStateValue: jobStateVal && (jobStateVal.trim() !== '') ? jobStateVal : jobStateValue,
            q: query,
            page: page,
            sortBy: sortBy,
            overlayMode: mode,
            multiValSelect: multiValSelect
        });
    },

    //Campaign overlay.
    getCampaignsOverlay: function (page, sortBy, identifier) {
        var _modal = JV.Modal;
        var query = $('#jv-campaignText').val();
        var contactIds = (typeof this.getSelectedAppIds !== 'undefined') ? this.getSelectedAppIds() : $('#contactIds').val();
        var _identifier = identifier ? identifier : $('form[TYPE="OVERLAY"][KEY="CAMPAIGN"]').attr('IDENTIFIER');
        $('#jv-campaignLoadingStateWrapper').removeClass('jv-hide').addClass('jv-show');
        _modal.render({
            action: 'getCampaigns',
            q: query,
            page: page,
            sortBy: sortBy,
            campaignStatus: $('#jv-campaignStatus').val(), // used while sorting.
            identifier: _identifier,
            contactIds: contactIds
        });
    },

    stopProcessingContacts: function (key) {
        $(key).attr('onclick', '');
        $($($(key).children()[0]).children()[1]).text(i18n['JV_NEWPERSON_PROCESSING_']);
        $($($('span[KEY="CANCEL"]').children()[0]).children()[1]).text(i18n['JV_NEWPERSON_CLOSE']);
    },

    addToCampaign: function (callback) {
        var selectedCampaign = $('input:radio[name=campaignIds]:checked').val();
        if (!selectedCampaign) {
            $('.jv-modalWrapper #jv-selectError').html(JV.Person.Const['CAMPAIGN_ERROR']);
            return false;
        }
        this.submitForm('addToCampaignForm', callback);
    },

    //VA: getting used at the add contacts page when the user click on submit. It submits the data to the backend.
    /**
     *
     * @param {Object} iframeId: Id of the frame whose contents need to be submitted.
     * @param {Object} id: contact Id.
     * @param {Object} type: Resume coverletter
     * @param {Object} callback: callback will be called if provided otherwise a common default message would be shown.
     */
    submitResumeData: function (iframeId, id, type, callback) {
        var _frameContents = $('#' + iframeId).contents();
        
        if (_frameContents.find('input[name=data]').val() === undefined || _frameContents.find('input[name=data]').val() === null || _frameContents.find('input[name=data]').val().trim() === '') {
            return false;
        }
        var _url = JV.IMPORT_FILE_AJAX_URL + '&ids=' + id + '&kind=' + type;
        _frameContents.find('input[name=data]').upload(_url, _frameContents.serialize(), function (data) {
            // Hide the dialog in any case.
            JV.Modal.hide();
            if (!!data && !!callback) {
                callback(data);
            } else {
                JV.Util.showMessage(JV.Person.Const['CONTACT_SUCCESSFUL']);
            }
        });
        return true;
    },

    loadPerson: function (page) {
        $('#jv-personViewLoadingStateWrapper').removeClass('jv-show').addClass('jv-hide');
        var _selectedText = $('#jv-personText').val();
        var _roles = '';
        var _sourceKind = $('#jv-sourceIds :selected').attr('jvsourceTypeKind');
        if (_sourceKind === 'EnteredByRecruiter') {
            _roles = ['Recruiter', 'Research'];
        } else if (_sourceKind === 'EnteredByHiringManager') {
            _roles = ['HiringManager'];
        }

        this.loadPersonHelper(_selectedText, _roles, page);
    },

    //VA: also called from assigned user call.
    loadPersonHelper: function (selectedText, selectedSource, page, ifAssignedToCall) {
        var argsObj = {};
        argsObj.action = 'getPerson';
            argsObj.q = selectedText;
            argsObj.personType = selectedSource;
            argsObj.url = JV.GET_REQUISITION_URL;
            argsObj.page = page;
        if (ifAssignedToCall) {
            argsObj.assignedUserType = true;
        }
        JV.Modal.render(argsObj, null, false);
    },


    // This is used for input validation on iframe form contents mostly overlays.
    populateNameField: function () {
        var _frameContents = $('#importFileUploadContent').contents();
        if (_frameContents.find('input[name="data"]').val() !== '') {
            var objRE = new RegExp(/([^\/\\]+)$/);
            var _strName = '';
            var strName = objRE.exec(_frameContents.find('input[name="data"]').val());
            if (strName != null) {
                _strName = strName[0];
            }
            $('#jv-attachmentName').val(_strName);
        }

        if ($('#jv-addContactFrameContainer').length > 0) {
            $('#jv-attachmentName').html(_frameContents.find('input[name=data]').val());
        }
    },

    submitWithoutChangeUrl: function (type, key) {
        var name = '';
        var value = '';
        switch (type) {
            case 'CLEAR_SEARCH':
                name = 'clear';
                value = 'search';
                break;
            case 'SEARCH':
                // only values with 2 are coming here so no worries to take care of other values.
                name = 'searchId';
                value = key;
                break;
            default:
                // Handle unexpected type values here
                break;
        }

        var selectedText = $('#' + JV.Person.elementConst['SAVED_SEARCH'] + ' option:selected').text();
        if (selectedText !== 'Saved Searches') {
            $('#jv-savedSearchQueryParam').attr('name', 'searchName');
            $('#jv-savedSearchQueryParam').attr('value', selectedText);
        }

        // set the values for the form and then submit the form.
        $('#jv-queryParam').attr('name', name);
        $('#jv-queryParam').attr('value', value);

        if ($('#jv-modalDialog div.jv-rowDiv').length === 0) {
            $('#jv-changeUrlForm input#jv-updateFetch').val(true);
            $('#jv-changeUrlForm').trigger('submit');
        } else if (type === 'SEARCH') {
            $('#jv-changeUrlForm').trigger('submit');
        } else {
            //nothing should happen.
        }
    },

    //Used on Contact list and Contact details page
    sendJobvitesEmail: function (emailsString) {
        //Return url
        $('#jv-returnUrl').val(JV.REFERRER).attr('name', 'referrer');
        // change the action for the form
        JV.SEND_JOBVITE_URL = JV.SEND_JOBVITE_URL || window.JV.SEND_JOBVITE_URL;
        $('#jv-changeUrlForm').attr('action', JV.SEND_JOBVITE_URL);
        // add the emails to send as the post. sjEmail is 'send jobvite emails' which is read by the send jobvite page and injected into the emails section.
        $('#jv-queryParam').val(emailsString).attr('name', 'sjEmails');
        // submit the form.
        $('#jv-changeUrlForm').trigger('submit');
    },

    /**
     *
     * @param {Object} String
     * @param {Object} Function
     */
    submitForm: function (formId, callback, errorCallback, url) {
        if (!errorCallback) {
            errorCallback = function () { };
        }

        $('#' + formId).on('submit', function () {
            // optional is needed so that we can use it to submit the forms for refreshing the pages.
            //TODO: Make a loading state for the modal dialog boxes.
            JV.Person.removeFadedText();
            var dataString;
            if (formId === 'addTaskForm') {
                dataString = $('input[id!=jv-taskEndDate], textArea', this).serialize();
                var dataString1 = dataString.split('&dueDate=')[0];
                var dataString2 = dataString.split('&dueDate=')[1];
                var $scope = angular.element('#jv-taskEndDate').scope();
                dataString2 = 'dueDate=' + $scope.taskDueDate + dataString2;
                dataString = dataString1 + '&' + dataString2;
            } else {
                dataString = $(this).serialize();
            }
            JV.AJAX_URL = JV.AJAX_URL || window.JV.AJAX_URL;
            JV.Util.makeAjaxRequest({
                type: 'POST',
                url: url ? url : JV.AJAX_URL,
                data: dataString,
                ajaxType: formId,
                success: function (data) {
                    //VA: TODO: need to remove these hardcoding from the generics.
                    if (formId === 'rejectForm' || formId === 'doDeleteSavedSearch') {
                        JV.Modal.hide();
                    }
                    callback(data);
                },
                error: function (args) {
                    //VA: TODO: need to remove these hardcoding from the generics.
                    if (formId === 'rejectForm' || formId === 'doDeleteSavedSearch') {
                        JV.Modal.hide();
                    }
                    errorCallback(args);
                }
            });
            //VA: TODO: need to remove these hardcoding from the generics.
            if (formId === 'rejectForm' || formId === 'doDeleteSavedSearch') {
                JV.Util.showLoadingState();
            }
            return false;
        });
        $('#' + formId).trigger('submit');
        JV.Person.addFadedText();
        // Otherwise it will keep firing all the bounded submit events again and again.
        $('#' + formId).off('submit');
    }
};

JV.Person.Source = {

    isInternalSourceType: function (kind) {
        switch (kind) {
            case 'Referral':
            case 'EmployeeEntered':
            case 'EnteredForEmployee':
            case 'EnteredByHiringManager':
            case 'EnteredByRecruiter':
                return true;
            default:
                return false;
        }
    },
    isAgencySourceType: function (kind) {
        switch (kind) {
            case 'Agency':
                return true;
            default:
                return false;
        }
    },
    isDetailEditSourceType: function (kind, sourceIds) {
        var sourceTypePrompt;
        switch (kind) {
            case 'JobBoard':
            case 'Email':
            case 'FederatedSearch':
            case 'ResumeSearch':
                return true;
            default:
                sourceTypePrompt = $(sourceIds).attr('jvsourceTypePrompt') || [];
                return (sourceTypePrompt.length > 0);
        }
    },
    isDetailsSourceType: function (sourceIds) {
        var kind = $(sourceIds).attr('jvsourceTypeKind');
        if (this.isInternalSourceType(kind) || this.isAgencySourceType(kind) || this.isDetailEditSourceType(kind, sourceIds) || this.isNestedSourceType(sourceIds)) {
            return true;
        }
        return false;
    },
    isNestedSourceType: function (sourceIds) {
        var nestedCount = $(sourceIds).attr('jvsourceTypeNestedCount');
        if (nestedCount > 0) {
            return true;
        }
        return false;
    },
    showSourceDetails: function (sourceName, show, disable) {
        sourceName.select2('destroy');
        sourceName.val('');
        if (show) {
            sourceName.removeClass('jv-hide').addClass('jv-show');
            $('.jv-clearSourceField').removeClass('jv-hide').addClass('jv-show');
        } else {
            sourceName.removeClass('jv-show').addClass('jv-hide');
            $('.jv-clearSourceField').removeClass('jv-show').addClass('jv-hide');
        }
        sourceName.prop('disabled', disable);
    },
    showAgencies: function (sourceName, jhireBaseUrl) {
        /**
         * FIXME: remove jhireBaseURl as this call goes to admin and remove the references.
         */
        var config = {
            placeholder: i18n['JV_NEWPERSON_SELECT_AGENCY'],
            id: 'fullName',
            allowClear: true,
            ajax: {
                url: jvUrls.admin + '/action/user/search?action=getEmployees&pageSize=50&page=0&fieldId=-21',
                data: function (term, page) {
                    var pageSize = term && 10 || 50,
                        result = {
                            q: term,
                            pageSize: pageSize,
                            page: page - 1
                        };
                    return result;
                },
                results: function (data, page) {
                    var more = data.employees.length === 10;
                    return {
                        results: data.employees,
                        more: more
                    };
                }
            },
            formatResult: function (employee) {
                return '<strong>' + employee.fullName + '</strong> (' + employee.email + ')';
            },
            formatSelection: function (employee) {
                $('#jv-sourcedByEId').val(employee.EId);
                return employee.fullName;
            },
            initSelection: function (element, callback) {
                var url = config.ajax.url,
                    isMultiple = element.attr('multiple');
                if (isMultiple) {
                    url += '&ids=' + element.val();
                } else {
                    url += '&ids=' + element.val().split(',').join('&ids=');
                }

                $.ajax({
                    method: 'GET', url: url, success: function (data) {
                        data = config.ajax.results(data).results;
                        if (data.length) {
                            data = data[0];
                        } else {
                            data = false;
                        }
                        callback(data);
                    }
                });
            }
        };
        sourceName.select2(config);
    },
    showSubSources: function (sourceName, subSources) {
        sourceName.select2({
            placeholder: 'Select',
            allowClear: true,
            id: 'value',
            data: subSources,
            formatResult: function (data) {
                //console.log('formatResult: '+data);
                return '<strong>' + data.value + '</strong> ';
            },
            formatSelection: function (data) {
                //console.log('formatSelection: '+data);
                return data.value;
            },
            initSelection: function (elem, callback) {
                callback({ text: elem.val() });
            }
        });
    }
}; //end NewPerson namespace

// The only global function for navigation.
function jvNavHeighlight() {
    navhighlight('CONTACTS');
}

/**************************************************************************
 * Page Initialization for both the contacts and the candidates.
 *
**************************************************************************/
$(document).ready(function () {
    JV.TempPerson = JV.TempPerson || window.JV.TempPerson;
    // Highlight the tab bar at the top of the navigation.
    //For navigations
    $(':checkbox, :input').attr('autocomplete', 'off');
    //$('*').attr('autocomplete', 'off');
    if (JV && JV.Person) {
        $.extend(true, JV.Person, JV.TempPerson);
    } else {
        // otherwise overwrite the JV.Person properties.
        JV.Person = JV.TempPerson;
    }
    // nullify it.
    if (JV && JV.Person) {
        var me = JV.Person;
        //initialize the model.
        JV.Modal.initialize();
        me.attachParentEvent();
        //Initialize function is available in JV.TempPerson and required in Add/Edit Contact Details page. List page will not have this object hence keeping a null check
        if (JV.TempPerson) {
            me.initialize();
        }
        JV.TempPerson = null;
        window.JV.TempPerson = null;
    }
    $('#jv-modalDialog').jqDrag('.jqDrag');

    //tooltip
    $('.tooltip').jvtooltip({
        events: { def: 'click,mouseout' }
        //Vinoth: Removed position styling and added dynamic()
        // to position the tooltip based on <a>'s client area location.
    }).dynamic();
    $('.tooltipTh').jvtooltip({
        position: 'bottom center',
        offset: [10, 10]
    });
});

/* Distance change required as part of I18N */
/* Initializing the drop down values, basically as specified statically */
var distance = ['5', '10', '25', '50', '100'];

var sel = document.getElementById('distanceList');
if (sel) {
    for (var i = 0; i < distance.length; i++) {
        var opt = document.createElement('option'); /* Creation of select option drop down dynamically*/
        opt.innerHTML = distance[i] + ' ' + i18n[_jvselfUser.locale.unitOfDistance];
        opt.value = distance[i];
        sel.appendChild(opt);
    }
}

window.JV = window.JV || {};
window.JV.Util = JV.Util;
window.jvNavHeighlight = jvNavHeighlight;
window.JV.Person = window.JV.Person || JV.Person;
window.JV.Modal = window.JV.Modal || JV.Modal;